import { AppSettings } from 'core/AppSettings';
import { DateTime } from 'luxon';

type LoggerConfig = {
  error?: {
    logToServer?: boolean;
  };
};

type LogErrorToServerImplementation = (params: { error: string }) => void;
const DEFAULT_LOG_ERROR_TO_SERVER_IMPLEMENTATION: LogErrorToServerImplementation = ({ error }) => {
  console.error(`"logErrorToServer no implemented"\n${error}`);
};

let logErrorToServer: LogErrorToServerImplementation = DEFAULT_LOG_ERROR_TO_SERVER_IMPLEMENTATION;

const getLogger = (source: string, config?: LoggerConfig) => {
  return {
    error: (...data: any[]) => {
      const message = getDefaultErrorMessage(source, ...data);
      console.error(...message);
      if (!AppSettings.isProduction) return;
      if (!config?.error?.logToServer) return;
      logErrorToServer({ error: message.map(formatErrorMessagePart).join(' ') });
    },
    debug: (...data: any[]) => {
      if (AppSettings.isProduction) return;
      const message = getDefaultErrorMessage(source, ...data);
      console.log(...message);
    },
    warn: (...data: any[]) => {
      const message = getDefaultErrorMessage(source, ...data);
      console.warn(...message);
    },
    info: (...data: any[]) => {
      const message = getDefaultErrorMessage(source, ...data);
      console.log(...message);
    },
  };
};

function getDefaultErrorMessage(source: string, ...data: any[]) {
  const time = DateTime.now().toUTC().toString();
  return [`[${time}]`, `[${source}]`, ...data] as const;
}

function formatErrorMessagePart(value: unknown) {
  if (typeof value === 'string') return value;
  if (value === null || typeof value === 'undefined') return String(value);
  if (typeof value === 'object') return JSON.stringify(value, null, 2);
  return JSON.stringify(value);
}

function setLogErrorToServerImplementation(implementation: LogErrorToServerImplementation) {
  logErrorToServer = implementation;
}

const defaultExport = { getLogger, setLogErrorToServerImplementation };

export default defaultExport;
export const LogManager = { ...defaultExport };
